import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getQuickConnectsFilterItem,
  getClosureMsgFilterItem,
  getTemporaryMsgFilterItem,
  getMediaMgtFilterItem,
} from "../services/filter";

interface FilterState {
  status: string;
  quickConnectsFilterItem: string[];
  quickConnectsReset: boolean;
  closureMsgFilterItem: string[];
  closureMsgReset: boolean;
  temporaryMsgFilterItem: string[];
  temporaryMsgReset: boolean;
  mediaMgtFilterItem: string[];
  mediaMgtReset: boolean;
}

const initialState: FilterState = {
  status: "idle",
  quickConnectsFilterItem: [],
  quickConnectsReset: false,
  closureMsgFilterItem: [],
  closureMsgReset: false,
  temporaryMsgFilterItem: [],
  temporaryMsgReset: false,
  mediaMgtFilterItem: [],
  mediaMgtReset: false,
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    (builder.addCase(getQuickConnectsFilterItem, (state, action) => {
      state.quickConnectsFilterItem = action.payload as unknown as string[];
      state.quickConnectsReset = true;
    }),
      builder.addCase(getClosureMsgFilterItem, (state, action) => {
        state.closureMsgFilterItem = action.payload as unknown as string[];
        state.closureMsgReset = true;
      }),
      builder.addCase(getTemporaryMsgFilterItem, (state, action) => {
        state.temporaryMsgFilterItem = action.payload as unknown as string[];
        state.temporaryMsgReset = true;
      }),
      builder.addCase(getMediaMgtFilterItem, (state, action) => {
        state.mediaMgtFilterItem = action.payload as unknown as string[];
        state.mediaMgtReset = true;
      }));
  },
});

export default filterSlice.reducer;
